var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
    i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);
  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }
  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};
var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};
var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
    i,
    q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;
  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }
  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value) {
    resume("next", value);
  }
  function reject(value) {
    resume("throw", value);
  }
  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var Upload = /** @class */function (_super) {
  __extends(Upload, _super);
  function Upload() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Create a new upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/create
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.create = function (body) {
    return this.rawCreate(Utils.serializeRequestBody(body, {
      type: 'upload',
      attributes: ['path', 'copyright', 'author', 'notes', 'default_field_metadata', 'tags'],
      relationships: ['upload_collection']
    })).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Create a new upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/create
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawCreate = function (body) {
    return this.client.request({
      method: 'POST',
      url: '/uploads',
      body: body
    });
  };
  /**
   * List all uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/instances
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.list = function (queryParams) {
    return this.rawList(queryParams).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * List all uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/instances
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawList = function (queryParams) {
    return this.client.request({
      method: 'GET',
      url: '/uploads',
      queryParams: queryParams
    });
  };
  /**
   * Async iterator to auto-paginate over elements returned by list()
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/instances
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.listPagedIterator = function (queryParams, iteratorOptions) {
    return __asyncGenerator(this, arguments, function listPagedIterator_1() {
      var _a, _b, _c, element, e_1_1;
      var _d, e_1, _e, _f;
      return __generator(this, function (_g) {
        switch (_g.label) {
          case 0:
            _g.trys.push([0, 9, 10, 15]);
            _a = true, _b = __asyncValues(this.rawListPagedIterator(queryParams, iteratorOptions));
            _g.label = 1;
          case 1:
            return [4 /*yield*/, __await(_b.next())];
          case 2:
            if (!(_c = _g.sent(), _d = _c.done, !_d)) return [3 /*break*/, 8];
            _f = _c.value;
            _a = false;
            _g.label = 3;
          case 3:
            _g.trys.push([3,, 6, 7]);
            element = _f;
            return [4 /*yield*/, __await(Utils.deserializeJsonEntity(element))];
          case 4:
            return [4 /*yield*/, _g.sent()];
          case 5:
            _g.sent();
            return [3 /*break*/, 7];
          case 6:
            _a = true;
            return [7 /*endfinally*/];
          case 7:
            return [3 /*break*/, 1];
          case 8:
            return [3 /*break*/, 15];
          case 9:
            e_1_1 = _g.sent();
            e_1 = {
              error: e_1_1
            };
            return [3 /*break*/, 15];
          case 10:
            _g.trys.push([10,, 13, 14]);
            if (!(!_a && !_d && (_e = _b.return))) return [3 /*break*/, 12];
            return [4 /*yield*/, __await(_e.call(_b))];
          case 11:
            _g.sent();
            _g.label = 12;
          case 12:
            return [3 /*break*/, 14];
          case 13:
            if (e_1) throw e_1.error;
            return [7 /*endfinally*/];
          case 14:
            return [7 /*endfinally*/];
          case 15:
            return [2 /*return*/];
        }
      });
    });
  };
  /**
   * Async iterator to auto-paginate over elements returned by rawList()
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/instances
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawListPagedIterator = function (queryParams, iteratorOptions) {
    var _this = this;
    Utils.warnOnPageQueryParam(queryParams);
    return Utils.rawPageIterator({
      defaultLimit: 30,
      maxLimit: 500
    }, function (page) {
      return _this.rawList(__assign(__assign({}, queryParams), {
        page: page
      }));
    }, iteratorOptions);
  };
  /**
   * Retrieve an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/self
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.find = function (uploadId) {
    return this.rawFind(Utils.toId(uploadId)).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Retrieve an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/self
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawFind = function (uploadId) {
    return this.client.request({
      method: 'GET',
      url: "/uploads/".concat(uploadId)
    });
  };
  /**
   * Delete an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.destroy = function (uploadId) {
    return this.rawDestroy(Utils.toId(uploadId)).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Delete an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawDestroy = function (uploadId) {
    return this.client.request({
      method: 'DELETE',
      url: "/uploads/".concat(uploadId)
    });
  };
  /**
   * Update an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/update
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.update = function (uploadId, body) {
    return this.rawUpdate(Utils.toId(uploadId), Utils.serializeRequestBody(body, {
      id: Utils.toId(uploadId),
      type: 'upload',
      attributes: ['path', 'basename', 'copyright', 'author', 'notes', 'tags', 'default_field_metadata'],
      relationships: ['creator', 'upload_collection']
    })).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Update an upload
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/update
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawUpdate = function (uploadId, body) {
    return this.client.request({
      method: 'PUT',
      url: "/uploads/".concat(uploadId),
      body: body
    });
  };
  /**
   * Batch add tags to uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/batch_add_tags
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   *
   * @deprecated This API call is to be considered private and might change without notice
   */
  Upload.prototype.batchAddTags = function (body, queryParams) {
    return this.rawBatchAddTags(Utils.serializeRequestBody(body, {
      type: 'upload',
      attributes: ['tags'],
      relationships: []
    }), queryParams).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Batch add tags to uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/batch_add_tags
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   *
   * @deprecated This API call is to be considered private and might change without notice
   */
  Upload.prototype.rawBatchAddTags = function (body, queryParams) {
    return this.client.request({
      method: 'PUT',
      url: '/uploads/batch-add-tags',
      body: body,
      queryParams: queryParams
    });
  };
  /**
   * Delete multiple uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/batch_destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   *
   * @deprecated This API call is to be considered private and might change without notice
   */
  Upload.prototype.batchDestroy = function (queryParams) {
    return this.rawBatchDestroy(queryParams).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Delete multiple uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/batch_destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   *
   * @deprecated This API call is to be considered private and might change without notice
   */
  Upload.prototype.rawBatchDestroy = function (queryParams) {
    return this.client.request({
      method: 'DELETE',
      url: '/uploads/batch-destroy',
      queryParams: queryParams
    });
  };
  /**
   * Referenced records
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/references
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.references = function (uploadId, queryParams) {
    return this.rawReferences(Utils.toId(uploadId), queryParams).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Referenced records
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/references
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawReferences = function (uploadId, queryParams) {
    return this.client.request({
      method: 'GET',
      url: "/uploads/".concat(uploadId, "/references"),
      queryParams: queryParams
    });
  };
  /**
   * Add tags to assets in bulk
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_tag
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.bulkTag = function (body) {
    return this.rawBulkTag(Utils.serializeRequestBody(body, {
      type: 'upload_bulk_tag_operation',
      attributes: ['tags'],
      relationships: ['uploads']
    })).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Add tags to assets in bulk
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_tag
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawBulkTag = function (body) {
    return this.client.request({
      method: 'POST',
      url: '/uploads/bulk/tag',
      body: body
    });
  };
  /**
   * Put assets into a collection in bulk
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_set_upload_collection
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.bulkSetUploadCollection = function (body) {
    return this.rawBulkSetUploadCollection(Utils.serializeRequestBody(body, {
      type: 'upload_bulk_set_upload_collection_operation',
      attributes: [],
      relationships: ['upload_collection', 'uploads']
    })).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Put assets into a collection in bulk
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_set_upload_collection
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawBulkSetUploadCollection = function (body) {
    return this.client.request({
      method: 'POST',
      url: '/uploads/bulk/set-upload-collection',
      body: body
    });
  };
  /**
   * Destroy uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.bulkDestroy = function (body) {
    return this.rawBulkDestroy(Utils.serializeRequestBody(body, {
      type: 'upload_bulk_destroy_operation',
      attributes: [],
      relationships: ['uploads']
    })).then(function (body) {
      return Utils.deserializeResponseBody(body);
    });
  };
  /**
   * Destroy uploads
   *
   * Read more: https://www.datocms.com/docs/content-management-api/resources/upload/bulk_destroy
   *
   * @throws {ApiError}
   * @throws {TimeoutError}
   */
  Upload.prototype.rawBulkDestroy = function (body) {
    return this.client.request({
      method: 'POST',
      url: '/uploads/bulk/destroy',
      body: body
    });
  };
  Upload.TYPE = 'upload';
  return Upload;
}(BaseResource);
export default Upload;